export default "__VITE_ASSET__zJoaINfb__"